import { styled } from '@mui/material/styles'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { red } from '@mui/material/colors'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Pill from '../../../components/pill'
import {
  HorizontalRule as PriorityLowIcon,
  DensityLarge as PriorityMediumIcon,
  DensityMedium as PriorityHighIcon,
} from '@mui/icons-material'
import TextFieldWithTooltip from '../../../components/text_field_with_tooltip'
import { Box } from '@material-ui/core'

// const ExpandMore = styled((props) => {
//   const { expand, ...other } = props
//   return <IconButton {...other} />
// })(({ theme, expand }) => ({
//   transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
//   marginLeft: 'auto',
//   transition: theme.transitions.create('transform', {
//     duration: theme.transitions.duration.shortest,
//   }),
// }))

export default function CardTicket({ ticket }) {
  return (
    <Card
      sx={{
        maxWidth: 'calc(33.33% - 40px )',
        width: 'calc(33.33% - 40px)',
        minHeight: 425,
        maxHeight: 425,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        borderRadius: '8px',
        padding: '10px',
      }}
    >
      <Box>
        <CardHeader
          action={false}
          title={
            <Typography variant="h5">
              {ticket.libelle ? ticket.libelle.substring(0, 30) : ''}
            </Typography>
          }
          subheader={ticket.id ? `Référence #${ticket.id}` : null}
        />
        <CardContent sx={{ paddingTop: 0 }}>
          <Box marginTop={'10px'}>
            <Pill
              id={'ticket.process_name'}
              value={ticket.process_name}
              style={{ marginRight: '10px' }}
            />
          </Box>
          <Box marginTop={'10px'}>
            <Pill
              id={'ticket.process'}
              value={ticket.status}
              status="secondary"
              style={{ color: 'black', flex: 1 }}
            />
          </Box>
          <Box
            sx={{
              '&& p': {
                lineHeight: '26px !important',
                fontSize: '16px !important',
                padding: '20px 0',
              },
            }}
            marginTop={'10px'}
          >
            <TextFieldWithTooltip
              source="description"
              maxLength={200}
              record={ticket}
            />
          </Box>
        </CardContent>
      </Box>
      {/* <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
      </CardActions> */}
    </Card>
  )
}

const Priority = ({ ticket }) => {
  const getIcon = (p) => {
    switch (p) {
      case 1:
        return (
          <PriorityLowIcon
            style={{
              width: '15px',
              verticalAlign: 'middle',
            }}
          />
        )
      case 2:
        return (
          <PriorityMediumIcon
            style={{
              width: '15px',

              verticalAlign: 'middle',
            }}
          />
        )
      case 3:
        return (
          <PriorityHighIcon
            style={{
              width: '15px',
              verticalAlign: 'middle',
            }}
          />
        )
    }
  }

  const getColor = (p) => {
    switch (p) {
      case 1:
        return 'primary'
      case 2:
        return 'secondary'
      case 3:
        return 'error'
    }
  }
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Pill
          id={'ticket_details'}
          value={getIcon(ticket.priority)}
          status={getColor(ticket.priority)}
          borderRadius={5}
        />
      </div>
    </>
  )
}
